export const subtitles = {
  'splash.subtitles': [],
  'alive.subtitles': [],
  'silence.subtitles': [],

  'intro.subtitles': [
    {from: 0.0, to: 5.0, key: '1'},
    {from: 5.1, to: 11.5, key: '2'},
    {from: 11.6, to: 13.5, key: '3'},
    {from: 13.6, to: 19.0, key: '4'}
  ],

  'spectrogram.subtitles': [
    {from: 0.0, to: 2.2, key: '1'},
    {from: 2.3, to: 6.3, key: '2'},
    {from: 6.3, to: 11.6, key: '3'},
    {from: 13.0, to: 22.2, key: '4'},
    {from: 24.3, to: 31.1, key: '5'}
  ],

  'training_intro.subtitles': [],
  'training.subtitles': [],

  'science_intro_intro.subtitles': [
    {from: 0.0, to: 3.0, key: '1'},
    {from: 3.1, to: 9.0, key: '2'}
  ],

  'science_intro.subtitles': [
    {from: 2.1, to: 6.2, key: '1'},
    {from: 6.4, to: 10.2, key: '2'},
    {from: 10.4, to: 15.2, key: '3-1'},
    {from: 15.4, to: 19.0, key: '3-2'},
    {from: 19.1, to: 26.1, key: '4'},
    {from: 26.2, to: 30.0, key: '5'},
    {from: 30.1, to: 35.0, key: '6'},
    {from: 35.1, to: 41.0, key: '6-1'},
    {from: 39.1, to: 45.2, key: '6-2'},
    {from: 46.0, to: 49.0, key: '7'}
  ],

  'listen_intro.subtitles': [],
  'listen.subtitles': [],
  'listen_again.subtitles': [],

  'spectrogram_intro.subtitles': [
    {from: 0.0, to: 3.3, key: '1'},
    {from: 3.3, to: 5.0, key: '1-1'},
    {from: 6.0, to: 10.7, key: '2'},
    {from: 10.7, to: 12.5, key: '2-1'},
    {from: 12.7, to: 17.2, key: '2-2'},
    {from: 19.0, to: 24.0, key: '2-3'},
    {from: 25.1, to: 30.0, key: '3'},
    {from: 30.1, to: 33.0, key: '3-1'},
    {from: 33.1, to: 34.0, key: '3-2'},
    {from: 39.3, to: 44.0, key: '4'},
    {from: 45.0, to: 47.7, key: '4-1'},
    {from: 47.7, to: 49.7, key: '4-2'},
    {from: 50.3, to: 56.0, key: '4-3'},
    {from: 56.3, to: 58.5, key: '4-4'},
    {from: 58.6, to: 61.4, key: '5'},
    {from: 61.5, to: 63.0, key: '5-1'},
    {from: 63.1, to: 66.0, key: '5-2'}
  ],

  'outro.subtitles': [
    {from: 1.0, to: 3.3, key: '1.1'},
    {from: 3.4, to: 10.7, key: '1.2'},
    {from: 10.8, to: 17.1, key: '1.3'},
    {from: 17.2, to: 24.5, key: '2.1'},
    {from: 24.6, to: 27.9, key: '2.2'},
    {from: 28.0, to: 33.0, key: '2.3'},
    {from: 33.2, to: 40.0, key: '3'}
  ],

  'thanks.subtitles': []
}

export function subtitle(key, time) {
  if (!key || !subtitles[key]) return null

  // Returns first subtitle that matches the given time
  const videoSubtitles = subtitles[key]

  if (!videoSubtitles) {
    throw new Error(`No subtitles for ${key}`)
  }

  const subtitle = videoSubtitles.find((subtitle) => {
    return subtitle.from <= time && subtitle.to >= time
  })

  return subtitle ? subtitle.key : null
}
